import React, { Component } from 'react';
import { branch } from 'baobab-react/higher-order';
import request from 'superagent';
// import { find } from 'lodash';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';

class SearchProduct extends Component {
	constructor(props) {
		super(props);

		this.state = {
			products: [],
			options: [],
			selected: null
		};
	}

	handleSearch(query) {
		if (!query) {
			return;
		}
		request.get(`/api/product/search?skuNumber=${query}`)
			.set('authorization', this.props.token)
			.then(resp => JSON.parse(resp.text))
			.then(products => {
				const options = products.filter(product => !product.discontinued)
					.map(product => product.modelNumber);
				this.setState({ products, options });
			});
	}

	handleClick(data) {
		this.setState({ selected: data });
		this.setState({ options: [] });
	}

	handleDropdownClick(e, option) {
		global.dataLayer.push({
			event: 'Support',
			eventCategory: 'Support',
			eventAction: 'Product Manual',
			eventLabel: e.currentTarget.textContent
		});

		window.location.href = `/about-my-safe/${option}`;
	}

	render() {
		let placeHolder = 'Enter Model Number';

		return (
			<div>
				<AsyncTypeahead
					labelKey="login"
					onSearch={query => this.handleSearch(query)}
					options={this.state.options}
					placeholder={placeHolder}
					filterBy={option => option}
					renderMenuItemChildren={option => (
						<span onClick={e => this.handleDropdownClick(e, option)}>
							{option}
						</span>
					)}
				/>
			</div>
		);
	}
}

export default branch({
	token: ['token'],
	product: ['product']
}, SearchProduct);


// WEBPACK FOOTER //
// ./src/pages/aboutMySafe/SearchProduct.js